// What an eBay reply or step box is loaded with (docs/decisions.md,
// 2026-09-29): the shared ebayPlainText() first, which converts only text
// that actually carries HTML and leaves plain text byte-for-byte, then the
// agent-name placeholders resolved by the send path's own rule
// (resolvePlaceholderSignature() -> the shared resolveAgentNamePlaceholders()).
// The result is exactly what services/send-approved-reply.js and
// action-executor.js transmit. Called once per load, never on a keystroke.
// Kept out of SuggestionPanel.jsx so it is unit-testable without React.
import { ebayPlainText } from '@cxhub/shared'
import { resolvePlaceholderSignature } from './constants/companies.js'

export function loadEbayBoxText(text, account, firstName) {
  if (text == null) return text
  return resolvePlaceholderSignature(ebayPlainText(text), account, firstName)
}
